module.exports = __webpack_public_path__ + "img/BYOCS_Icons_SDOH_Economic_noBG.0387ff68.png";